import Navbar from "./Components/navbar";
import Intro from "./Components/intro";
import About from "./Components/about";
import Projects from "./Components/projects";
import Contact from "./Components/contact";
import Footer from "./Components/footer";

function App() {
  return (
    <>
      <Navbar />
      <Intro />
      <About />
      <Projects />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
